import { useState, useRef, useEffect } from 'react';
import '../../styles/TripEditor.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useToast } from '../ToastContext';
import ReactGA from 'react-ga4';

function NewTripEditor() {
    const API_URL = process.env.REACT_APP_API_URL;

    const navigate = useNavigate();

    const { showToast } = useToast();

    const maxCharLimit = 3000;

    const countryName = localStorage.getItem("selectedCountryName");
    const countryId = localStorage.getItem("selectedCountryDbId"); //Pobrane z trip z pobrania danych id kraju z bd

    const userId = localStorage.getItem("userId")

    const [isUploading, setIsUploading] = useState(false);

    const [titleData, setTitleData] = useState("");
    const [descriptionData, setDescriptionData] = useState("");
    const [arrivalDateData, setArrivalDateData] = useState("");
    const [departureDateData, setDepartureDateData] = useState("");
    const [photos, setPhotos] = useState([]);

    const textareaRef = useRef(null);
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
        }
    }, [descriptionData]);

    const handleFiles = (e) => {
        const selected = Array.from(e.target.files);
        const images = selected.filter(file => file.type.startsWith("image/"));
        setPhotos(prev => [...prev, ...images]);
    };

    const addTrip = async (e) => {
        e.preventDefault();
        

        // Walidacja danych pod kątem braku identyfikatorów
        if (!userId) {
            showToast("Brak danych użytkownika", "error")
            return;
        }
        if (!countryId) {
            showToast("Brak danych kraju", "error")
            return;
        }
        

        const filesAmountLimit = 30;

        if (photos.length > filesAmountLimit) {
            showToast(`Maksymalnie na raz możesz dodać ${filesAmountLimit} zdjęć!`, "error");
            e.target.value = null;
            return;
        }

        if (photos.length > 5) {
            setIsUploading(true);
        }

        const tripData = {
            title: titleData,
            description: descriptionData,
            arrivalDate: arrivalDateData,
            departureDate: departureDateData,
            userId: Number(userId),
            countryId: countryId, 
        };

        try {
            // 1. Zapisujemy wycieczkę
            const tripResponse = await axios.post(`${API_URL}/trips/addTrip`, tripData);
            const tripId = tripResponse.data.id;

            // 2. Jeśli są zdjęcia, wysyłamy je i CZEKAMY (await) na koniec przesyłania
            if (photos && photos.length > 0) {
                const formData = new FormData();
                formData.append("tripId", tripId);
                formData.append("userId", userId);

                photos.forEach(photo => {
                    formData.append("images", photo);
                });

                // Kluczowe dodanie AWAIT:
                await axios.post(`${API_URL}/pictures/upload`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }

            //GA
            ReactGA.event({
                category: 'Journal',
                action: 'add_trip_entry',
                label: countryName
            });

            showToast("Wycieczka dodana pomyślnie", "success");
            navigate("/globus");
            setIsUploading(false);
            e.target.value = null;

        } catch (error) {
            showToast("Wystąpił błąd podczas dodawania wpisu/zdjęć.", "error");
        }
    };

    return (
        <>
            <div className="NewTripEditor">
                <button className="backButton" onClick={() => navigate('/globus')}>Cofnij</button>
                <form onSubmit={addTrip}>
                    <h1>Nowy wpis</h1>
                    <h3>Kraj: {countryName}

                    </h3>
                    <p>Data przyjazdu:
                        <input type='date' onChange={(e) => setArrivalDateData(e.target.value)} max={departureDateData} required></input>
                    </p>

                    <p>Tytuł:
                        <input type='text' onChange={(e) => setTitleData(e.target.value)} maxLength={50} placeholder='Nadaj tytuł dla wpisu (Pole opcjonalne)' />
                    </p>

                    <p>Opis:
                        <div style={{ position: 'relative', width: '100%' }}>
                            <textarea
                                ref={textareaRef}
                                maxLength={maxCharLimit}
                                placeholder="Opisz swoją podróż..."
                                value={descriptionData}
                                onChange={(e) => setDescriptionData(e.target.value)}
                                required
                                style={{
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    paddingBottom: '30px',
                                    resize: 'vertical',
                                    height: '200px',
                                }}
                            ></textarea>
                            <span
                                style={{
                                    position: 'absolute',
                                    bottom: '10px',
                                    right: '12px',
                                    fontSize: '0.85rem',
                                    color: (descriptionData?.length || 0) >= maxCharLimit ? '#d9534f' : '#888',
                                    pointerEvents: 'none',
                                    userSelect: 'none',
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    padding: '2px 6px',
                                    borderRadius: '4px'
                                }}
                            >
                                {descriptionData?.length || 0}/{maxCharLimit}
                            </span>
                        </div>
                    </p>

                    <p>Data wyjazdu:
                        <input type='date' onChange={(e) => setDepartureDateData(e.target.value)} required min={arrivalDateData}></input>
                    </p>

                    <p>Dodaj zdjęcia (można je również dodać później): </p>
                    <p><input type='file' multiple accept='image/*' onChange={handleFiles} /></p>
                    <div className='buttons'><button type='submit'>Dodaj wpis</button><button type='reset'>Wyczyść</button></div>
                </form>
                <br></br>

                {/*ZDJECIA */}
                <div className='photosGrid'>
                    {photos.map((file, index) => (
                        <div className='photoTile' key={index}>
                            <img
                                src={URL.createObjectURL(file)}
                                alt=""
                                width="100"
                                style={{ borderRadius: "8px" }}
                            />

                            <button className="deletePhoto" onClick={() => setPhotos(prev => prev.filter((_, i) => i !== index))}>{/*zapisywanie wszystkich zdjęć w setPhotos poza wybranym do usunięcia*/}
                                ✕
                            </button>
                        </div>
                    ))}
                </div>
            </div>
            {isUploading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    backdropFilter: 'blur(3px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000
                }}>
                    <div style={{
                        backgroundColor: '#ffffff',
                        padding: '30px 40px',
                        borderRadius: '16px',
                        textAlign: 'center',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        {/* Animowany Spinner CSS */}
                        <div className="upload-spinner"></div>

                        <div>
                            <h3 style={{ margin: '0 0 6px 0', fontSize: '1.2rem', color: '#1e293b' }}>
                                Trwa wysyłanie zdjęć...
                            </h3>
                            <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748b' }}>
                                Proszę czekać, zdjęcia są zapisywane w bazie.
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
export default NewTripEditor;